module.exports = __webpack_public_path__ + "static/media/client-logo.8bddea15.jpg";